export default {"src":"/_next/static/media/magic-wand.6ec91b6a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};